import React from 'react';

import { Formik, Field } from 'formik';
import * as Yup from 'yup';

import { useToast } from 'Hooks/useToast';

import CircleCheckIcon from 'Assets/icons/circle-check.svg';
import XMarkIcon from 'Assets/icons/circle-xmark.svg';

const DefinitionEditSchema = Yup.object().shape({
    description: Yup.string().nullable(),
});

export default function GeneralRiskDefinitionsTableEditRow(props) {
    const toast = useToast();

    return (
        <tr>
            <Formik
                initialValues={{
                    description: props.definition.description ?? '',
                }}
                validationSchema={DefinitionEditSchema}
                onSubmit={(values, actions) => {
                    const data = { ...values };

                    axios
                        .put(props.updateUrl, data)
                        .then(() => {
                            props.onCancel();
                            props.onUpdated();
                            toast.success($t('general risk definition updated successfully'));
                        })
                        .catch((e) => {
                            actions.setSubmitting(false);
                            toast.error($t('general risk definition update failed'));
                        });
                }}
            >
                {({ errors, touched, isSubmitting, handleSubmit }) => (
                    <>
                        <td className="tw-align-top">{props.definition.category_label}</td>
                        <td>
                            <Field
                                as="textarea"
                                className={`tw-block tw-w-full tw-rounded-lg tw-text-sm tw-bg-grey/50 tw-text-charcoal tw-resize-none hover:tw-resize-y ${
                                    errors.description && touched.description ? 'is-invalid border border-danger' : ''
                                }`}
                                name="description"
                                placeholder={$t('description')}
                            />
                        </td>
                        <td>
                            <div className="tw-flex tw-items-center tw-gap-x-3.5">
                                <button
                                    type="button"
                                    className="tw-flex tw-items-center tw-gap-x-1.5 tw-text-sm tw-font-semibold tw-text-red"
                                    onClick={props.onCancel}
                                >
                                    <XMarkIcon />
                                    <div>{$t('Cancel')}</div>
                                </button>
                                <button
                                    type="button"
                                    className="tw-flex tw-items-center tw-gap-x-1.5 tw-text-sm tw-font-semibold tw-text-blue"
                                    disabled={isSubmitting}
                                    onClick={handleSubmit}
                                >
                                    <CircleCheckIcon />
                                    <div>{$t('Save')}</div>
                                </button>
                            </div>
                        </td>
                    </>
                )}
            </Formik>
        </tr>
    );
}
